import { render, staticRenderFns } from "./ViewUserRole.vue?vue&type=template&id=15cc03e2"
import script from "./ViewUserRole.vue?vue&type=script&lang=js"
export * from "./ViewUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports